<template>
    <md-dialog
        :md-active.sync="isDialogVisible"
        :md-click-outside-to-close="true"
    class="fixed-dialog">
        <md-dialog-title>Choose a workflow from the library</md-dialog-title>
        <md-dialog-content class="dialog-content">
            <div class="library-row">
                <div class="library-column">
                    <FeaturedBlocks
                        :featuredWorkflowBlocks="featuredWorkflowBlocks"
                        @view-featured-workflow="(block) => viewFeaturedWorkflow(block)"
                        @featured-block="loadFeaturedBlock"
                        />
                </div>
                <div class="library-column">
                    <FeaturedBlockViewer
                        :selectedFeaturedBlock="selectedFeaturedBlock"
                        @featured-block="loadFeaturedBlock"
                    />
                </div>
            </div>
        </md-dialog-content>

        <md-dialog-actions>
            <md-button class="md-primary" @click="closeDialog">
                Close
            </md-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import FeaturedBlocks from "@/components/FeaturedBlocks.vue";
import FeaturedBlockViewer from "@/components/FeaturedBlockViewer.vue";
import { getFeaturedWorkflows } from '@/blocks/featured_workflows';
import { ConfigService } from '@/services/config.service';
import { AuthService } from '@/services/auth.service';

export default {
    name: "FeaturedWorkflowsLoad",
    data: () => ({
        isDialogVisible: false,
        featuredWorkflowBlocks: [],
        selectedFeaturedBlock: null,
        orgId: null,
        orgType: null,
    }),
    components: {
        FeaturedBlocks,
        FeaturedBlockViewer
    },
    methods: {
        showDialog() {
            this.isDialogVisible = true;
        },
        closeDialog() {
            this.isDialogVisible = false;
        },
        viewFeaturedWorkflow(block) {
            this.selectedFeaturedBlock = block;
        },
        loadFeaturedBlock(id) {
            this.$emit('load-featured-block', id)
            this.isDialogVisible = false;
        }
    },
    created() {
        this.subscription = AuthService.loggedUser$.subscribe((user) => {
            this.orgId = user.orgId;

            ConfigService.getOrgConfig(this.orgId).then(function(config){
                this.orgType = config.accessType;
                this.featuredWorkflowBlocks = getFeaturedWorkflows(config)
                this.selectedFeaturedBlock = this.featuredWorkflowBlocks[0];
            }.bind(this));

        });

    },
    beforeDestroy() {
        this.subscription.unsubscribe();
    }
};
</script>

<style scoped lang="scss">
.md-dialog-title {
    margin-bottom: 0;
}
.dialog-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    hr {
        color: #d0d0d0;
    }

    .saved-workflows {
        border-bottom: 1px solid #d0d0d0;
    }
}
.library-row {
    display: flex;
    height: 100%;
}
.library-column {
    flex: 50%;
    display: flex;
    overflow: auto;
    flex-direction: column;
    padding: 0 20px;

    &:first-of-type {
        border-right: 1px solid #d0d0d0;
    }
}
</style>
